



















import { Component, Prop, Vue } from 'vue-property-decorator';
import Datepicker from 'vuejs-datepicker';
import { ru } from '@/locale';

@Component({
  components: {
    Datepicker,
  },
})
export default class ComponentsFormDatepicker extends Vue {
  @Prop({ type: String, default: 'uniquename' })
  name: string;

  @Prop({ type: String, default: '' })
  label: string;

  @Prop({ type: Boolean, default: false })
  readonly required!: boolean;

  @Prop({ type: [String, Date], default: '' })
  value: string | Date;

  @Prop({ type: String, default: 'Выберите дату' })
  placeholder: string;

  @Prop({ type: String, default: '' })
  errorText: string;

  @Prop({ type: Object, default: () => {} })
  disabledDates: any;

  @Prop({ type: Object, default: () => {} })
  highlighted: any;

  @Prop({ type: [Object, Function], default: () => {} })
  v: any;

  rusland: any = ru;

  get vError(): boolean {
    return this.v && this.v.$error;
  }

  get addClass(): string {
    return this.vError
      ? 'vdp-datepicker-view vdp-datepicker-view_error form-select'
      : 'vdp-datepicker-view form-select';
  }

  selectDate($events: any) {
    this.$emit('input', $events);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/form/components/datepicker/Datepicker.vue